// ~/store/general.ts
import { defineStore } from 'pinia'

/**
 * Pinia store for global app state.
 * Manages the age-gate modal visibility and the user's confirmed adult status.
 */
export const useGeneralStore = defineStore('general', {
	state: () => ({
		show_modal_age_verification: false as boolean,
		is_adult: null as boolean | null,
	}),

	actions: {
		/** Initialises the age-gate from a stored value; shows the modal when the value is `null`. */
		initAgeGate(value: boolean | null) {
			this.is_adult = value
			this.show_modal_age_verification = value === null
		},

		/** Sets any top-level state property by key. */
		SET_STATE_GENERAL({ type, value }: { type: string; value: any }) {
			;(this as any)[type] = value
		},
	},
})
